import type {summaryContent} from '../../../core/repositories/reportSummaryRepository';

export function useParseJson() {
  const parseJson = (json: string): summaryContent => {
    try {
      let parsed = JSON.parse(json);
      parsed = toCamelCase(parsed);
      return parsed as summaryContent;
    } catch (error) {
      console.error('Invalid JSON:', json);
      throw error;
    }
  };

  const toCamelCase = (obj: any): any => {
    if (Array.isArray(obj)) {
      return obj.map((v): any => toCamelCase(v));
    }

    if (obj !== null && obj.constructor === Object) {
      return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => [
          key.replaceAll(/([-_][a-z])/g, (group) =>
            group.toUpperCase().replace('-', '').replace('_', ''),
          ),
          toCamelCase(value),
        ]),
      );
    }

    return obj;
  };

  return {parseJson};
}
